import React from 'react';
import "./Disclaimer.scss"

const Disclaimer = () => (

	<div className='Disclaimer_page'>
		<div className="List_header">
			<h5 className="MH">Disclaimer</h5>
		</div>
		<div className='mt-3 row mx-0'>
			<div className='col-lg-10'>
				<section className='Disclaimer_page_01'>
					<div className='p-2'>
						<h5 className='m-0'>Disclaimer - GRI Resource Center</h5>
					</div>
					<div className='p-2'>
						<p>For the latest version of the GRI Standards, including the revised Universal Standards, adapted Topic Standards, Sector Standards, their recommendations and guidance sections, as well as the GRI Standards Glossary, please visit the GRI Resource center:
							<a className='mx-2' target='_blank' href='https://www.globalreporting.org/how-to-use-the-gri-standards/resource-center'>https://www.globalreporting.org/how-to-use-the-gri-standards/resource-center</a>
						</p>
					</div>
				</section>
				<section className='Disclaimer_page_01'>
					<div className='p-2'>
						<h5 className='m-0'>Disclaimer - Licensing</h5>
					</div>
					<div className='p-2'>
						<p>
							The GRI Standards are used by <b className='text-primary'>Travanleo info solutions </b> under licensed authority from GRI. GRI, as Licensor of the copyright in the GRI Standards, verified and validated the authentic and accurate  representation of the GRI Standards in <span className='fw-500'>Ecodrisil ESGXpress</span>. This verification was limited to ensuring the maintenance of the integrity, authenticity and accuracy of the Licensed Content. GRI therefore makes no implied or actual representations or warranties as to the correctness, compliance, trustworthiness, fitness of purpose or quality of <span className='fw-500'>Ecodrisil ESGXpress</span> or any products resulting therefrom; or of Licensee’s use of the GRI copyrighted content; and expressly disclaims any implied or express representations that any report produced by Licensee meets the standards of an approved GRI Standards Report.
						</p>
					</div>
				</section>
			</div>
		</div>

	</div>
);

export default Disclaimer;
